// context/PermissionsContext.js
import React, { createContext, useState, useEffect } from 'react';

export const PermissionsContext = createContext();
// utils/sectionEnums.js
export const SectionGroup = {
  EEDIRECTORY: 'EEDirectory',
  EMPLOYEERECORDS: 'EmployeeDirectory',
  GOALS_Company: 'Goals/Company',
  GOALS_COUNTRY: 'Goals/Country',
  GOALS_CELL: 'Goals/Cell',
  GOALS_EMPLOYEE: 'Goals/Employee',
  GOALS_PROFIT: 'Goals/ProfitAndRevenueTargets',
  GOALS_MINE: 'Goals/Mine',
  IMPORT_TOOL: 'ImportDataTool',
  FORM_TEMPLATES: 'FormTemplates',
  TRAINING_RESOURCE: 'TrainingResources',
  CLIENT_DIRECTORY: 'ClientDirectory',
  ANNOUNCEMENTS: 'Announcements',
};
export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(() => {
    const stored = localStorage.getItem('permissions');
    return stored ? JSON.parse(stored) : [];
  });

  // Function to filter permissions by section prefix and optionally departmentId
  const getPermissionsBySectionGroup = (sectionPrefix, departmentIdFilter = null) => {
    return permissions.filter((perm) => {
      const matchesSection = perm.section.startsWith(sectionPrefix);
      const matchesDepartment = departmentIdFilter
        ? perm.departmentId === departmentIdFilter
        : true;
      return matchesSection && matchesDepartment;
    });
  };
  const getPermissionsBySectionGroupNew = (sectionPrefix, departmentIdFilter = null, roleId) => {
    const permission = permissions.find((perm) => {
      const matchesSection = perm.section.startsWith(sectionPrefix);
      const matchesDepartment = departmentIdFilter
        ? perm.departmentId === departmentIdFilter
        : true;
      const matchesRole = perm.level === roleId;
      return matchesSection && matchesDepartment && matchesRole;
    });

    return permission?.accessType || null;
  };

  useEffect(() => {
    localStorage.setItem('permissions', JSON.stringify(permissions));
  }, [permissions]);

  return (
    <PermissionsContext.Provider
      value={{
        permissions,
        setPermissions,
        getPermissionsBySectionGroup, // Exposed via context
        getPermissionsBySectionGroupNew,
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};
